import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@lmc-env/environment';

@Injectable({
	providedIn: 'root',
})
export class ReportQueueService {
	private readonly uri: string = `${environment.DO_URL}/v2`;

	constructor(private readonly http: HttpClient) { }

	// Application CRUD operations
	getReportQueue(): Observable<any> {
		return this.http.get(`${this.uri}/report-queue`);
	}

	updateReport(data: any): Observable<any> {
		return this.http.put(`${this.uri}/report-queue/${data.report_id}`, data);
	}
}
